// Trauma shake (§11): offset = 0.35 m × trauma² × noise, roll = 1.5° × trauma² × noise, trauma
// decays 1.6/s. The noise is smooth (summed incommensurate sines per axis), so the shake reads as a
// physical jolt rather than jitter. The screen-shake setting scales it and Reduced Motion zeroes it.
export const SHAKE = { maxOffset: 0.35, maxRollDeg: 1.5, decayPerSec: 1.6, freq: 18 } as const;

function noise(t: number, seed: number): number {
  return (Math.sin(t * 1.0 + seed) * 0.5 + Math.sin(t * 2.31 + seed * 1.7) * 0.3 + Math.sin(t * 4.67 + seed * 2.3) * 0.2);
}

export class Shake {
  trauma = 0;
  private t = 0;
  /** This frame's offsets (camera right, camera up, meters) and roll (radians). */
  readonly out = { x: 0, y: 0, roll: 0 };

  add(a: number): void {
    this.trauma = Math.min(1, this.trauma + a);
  }

  /** Advances by `dt` (real seconds) and writes `out`; `scale` is 0..1 (0 under Reduced Motion). */
  update(dt: number, scale: number): void {
    this.t += dt * SHAKE.freq;
    this.trauma = Math.max(0, this.trauma - SHAKE.decayPerSec * dt);
    const k = this.trauma * this.trauma * scale;
    this.out.x = SHAKE.maxOffset * k * noise(this.t, 0.3);
    this.out.y = SHAKE.maxOffset * k * noise(this.t, 5.1);
    this.out.roll = ((SHAKE.maxRollDeg * Math.PI) / 180) * k * noise(this.t, 9.7);
  }

  reset(): void {
    this.trauma = 0;
    this.out.x = this.out.y = this.out.roll = 0;
  }
}
